var trim = require('./trim');

module.exports = function clean(str) {
  return trim(str).replace(/\s\s+/g, ' ');
};



//////////////////
// WEBPACK FOOTER
// ../~/underscore.string/clean.js
// module id = 735
// module chunks = 0